var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "details-view" },
    [
      _c(
        "cargo-left-right-resize",
        {
          staticStyle: { "min-height": "100%" },
          attrs: {
            "left-style": {
              flex: "none",
              "min-width": "180px",
              "max-width": "240px"
            },
            "right-style": { overflow: "hidden" },
            "show-left": _vm.action === "look",
            no: "1"
          }
        },
        [
          _c(
            "template",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.action === "look",
                  expression: "action==='look'"
                }
              ],
              slot: "left"
            },
            [
              _c("cargo-ag-grid", {
                staticClass: "section",
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.gridOptions,
                  "row-data": _vm.rowData,
                  "grid-style": "min-width: 180px;width:100%;height:100%;",
                  no: "2"
                },
                on: {
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c("template", { slot: "right" }, [
            _c("div", { staticClass: "main-content" }, [
              _c(
                "div",
                {
                  staticClass: "operations",
                  staticStyle: { "margin-bottom": "5px" }
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.action === "look",
                          expression: "action==='look'"
                        }
                      ]
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "3" },
                          on: { click: _vm.goBack }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Back")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.modelType !== 3,
                              expression: "modelType !== 3"
                            }
                          ],
                          attrs: {
                            disabled: !_vm.selectedRow,
                            type: "success",
                            no: "4"
                          },
                          on: {
                            click: function($event) {
                              return _vm.editHandler("edit")
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                ((_vm.modelType === 0 &&
                                  _vm.$checkPermission([
                                    "role_CRMMyCustomerManager_sign"
                                  ])) ||
                                  (_vm.modelType === 1 &&
                                    _vm.$checkPermission([
                                      "role_CRMMyGroupCustomerManager_sign"
                                    ]))) &&
                                !_vm.isEditing,
                              expression:
                                "((modelType === 0 && $checkPermission(['role_CRMMyCustomerManager_sign'])) || modelType === 1 && $checkPermission(['role_CRMMyGroupCustomerManager_sign'])) && !isEditing"
                            }
                          ],
                          attrs: { type: "primary", no: "5" },
                          on: {
                            click: function($event) {
                              return _vm.signHandler()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SignContract")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.modelType == 2 &&
                                !_vm.isEditing &&
                                _vm.$checkPermission([
                                  "role_CRMShareCustomerManager_assign"
                                ]),
                              expression:
                                "modelType == 2 && !isEditing && $checkPermission(['role_CRMShareCustomerManager_assign'])"
                            }
                          ],
                          attrs: { type: "primary", no: "6" },
                          on: { click: _vm.assignEventHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Distribution")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.modelType == 2 && !_vm.isEditing,
                              expression: "modelType == 2 && !isEditing"
                            }
                          ],
                          attrs: { type: "primary", no: "7" },
                          on: { click: _vm.assignMyEventHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AssignToMe")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.modelType == 2 &&
                                !_vm.isEditing &&
                                _vm.$checkPermission([
                                  "role_CRMShareCustomerManager_delete"
                                ]),
                              expression:
                                "modelType == 2 && !isEditing && $checkPermission(['role_CRMShareCustomerManager_delete'])"
                            }
                          ],
                          attrs: { type: "primary", no: "8" },
                          on: { click: _vm.deleteModelHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.modelType == 2 &&
                                !_vm.isEditing &&
                                _vm.$checkPermission([
                                  "role_CRMShareCustomerManager_assignDirect"
                                ]),
                              expression:
                                "modelType == 2 && !isEditing && $checkPermission(['role_CRMShareCustomerManager_assignDirect'])"
                            }
                          ],
                          attrs: { type: "primary", no: "9" },
                          on: { click: _vm.assignDirectEventHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DirectAssign")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.modelType == 3 &&
                                !_vm.isEditing &&
                                _vm.$checkPermission([
                                  "role_CRMRecoveryCustomerManager_recovery"
                                ]),
                              expression:
                                "modelType == 3 && !isEditing && $checkPermission(['role_CRMRecoveryCustomerManager_recovery'])"
                            }
                          ],
                          attrs: { type: "primary", no: "10" },
                          on: { click: _vm.recoveryHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Restore")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.action === "edit",
                          expression: "action==='edit'"
                        }
                      ],
                      staticStyle: {
                        "border-left": "none",
                        "padding-left": "0"
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success", no: "11" },
                          on: { click: _vm.save }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success", no: "12" },
                          on: {
                            click: function($event) {
                              _vm.cancelEdit(function() {
                                _vm.againShow("look")
                              })
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isNew,
                          expression: "isNew"
                        }
                      ],
                      staticClass: "new",
                      staticStyle: {
                        "border-left": "none",
                        "padding-left": "0"
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success", no: "13" },
                          on: { click: _vm.save }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success", no: "14" },
                          on: {
                            click: function($event) {
                              return _vm.cancelEdit(_vm.goBack)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "tabs-container" },
                [
                  _c(
                    "el-tabs",
                    {
                      ref: "tabs",
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "card",
                        "before-leave": function(activeName, oldActiveName) {
                          _vm.beforeLeaveTab(activeName, oldActiveName)
                        }
                      },
                      on: { "tab-click": _vm.handleTabClick },
                      model: {
                        value: _vm.activeTabName,
                        callback: function($$v) {
                          _vm.activeTabName = $$v
                        },
                        expression: "activeTabName"
                      }
                    },
                    [
                      _vm.selectedRow
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 1,
                              attrs: {
                                label: _vm.$t(
                                  "CargoMsg.Cargo_BasicInformation"
                                ),
                                lazy: true,
                                name: "tabCrmCustomer"
                              }
                            },
                            [
                              _c("tab-crm-customer", {
                                ref: "tabCrmCustomer",
                                attrs: {
                                  "model-type": _vm.modelType,
                                  "show-source-type": _vm.showSourceType,
                                  context: _vm.context,
                                  action: _vm.action
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      (_vm.modelType === 0
                      ? _vm.isShowTab &&
                        _vm.$checkPermission(["tab_TabCRMCustomerContact"])
                      : _vm.isShowTab)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 2,
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_Contact"),
                                lazy: true,
                                name: "tabCrmCustomerContact"
                              }
                            },
                            [
                              _c("tab-crm-customer-contact", {
                                ref: "tabCrmCustomerContact",
                                attrs: {
                                  "model-type": _vm.modelType,
                                  "show-source-type": _vm.showSourceType,
                                  context: _vm.context,
                                  action: _vm.action
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isShowTab || _vm.modelType === 2
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 3,
                              attrs: {
                                label: _vm.$t(
                                  "CargoMsg.Cargo_BusinessCharacteristic"
                                ),
                                lazy: true,
                                name: "tabCrmCustomerBussiness"
                              }
                            },
                            [
                              _c("tab-crm-customer-bussiness", {
                                ref: "tabCrmCustomerBussiness",
                                attrs: {
                                  "model-type": _vm.modelType,
                                  "show-source-type": _vm.showSourceType,
                                  context: _vm.context,
                                  action: _vm.action
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      (_vm.modelType === 0
                      ? _vm.isShowTab &&
                        _vm.$checkPermission(["tab_TabCRMCustomerEvent"])
                      : _vm.isShowTab)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 4,
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_EventRecord"),
                                lazy: true,
                                name: "tabCrmCustomerEvent"
                              }
                            },
                            [
                              _c("tab-crm-customer-event", {
                                ref: "tabCrmCustomerEvent",
                                attrs: {
                                  "model-type": _vm.modelType,
                                  "show-source-type": _vm.showSourceType,
                                  context: _vm.context,
                                  action: _vm.action
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      (_vm.modelType === 0
                      ? _vm.isShowTab &&
                        !_vm.isNew &&
                        _vm.selectedRow.uuid &&
                        _vm.$checkPermission(["tab_TabCRMCustomerFile"])
                      : _vm.isShowTab && !_vm.isNew && _vm.selectedRow.uuid)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 5,
                              attrs: {
                                label: _vm.$t(
                                  "CargoMsg.Cargo_FileDocumentation"
                                ),
                                lazy: true,
                                name: "tabCrmCustomerFile"
                              }
                            },
                            [
                              _c("tab-crm-customer-file", {
                                ref: "tabCrmCustomerFile",
                                attrs: {
                                  "model-type": _vm.modelType,
                                  "show-source-type": _vm.showSourceType,
                                  context: _vm.context,
                                  action: _vm.action
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ],
        2
      ),
      _c("sign-match-title-window", {
        attrs: {
          visible: _vm.signMatchTitleWindow.visible,
          "enabled-no-join": true,
          client: _vm.selectedRow || {},
          no: "15"
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.signMatchTitleWindow, "visible", $event)
          },
          signSuccessCallBack: _vm.signSuccessCallBackHandler
        }
      }),
      _vm.customerAssignWindow.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.customerAssignWindow.visible,
                title: _vm.$t("CargoMsg.Cargo_Distribution"),
                width: "360px",
                "close-on-click-modal": false,
                no: "16"
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.customerAssignWindow, "visible", $event)
                }
              }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "85px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.sales") } },
                    [
                      _c("cargo-user-select", {
                        staticStyle: { width: "230px" },
                        attrs: {
                          "method-params": { category: "role", shape: "sales" },
                          "default-value": _vm.customerAssignWindow.sales || "",
                          no: "17"
                        },
                        on: {
                          change: function(p) {
                            _vm.customerAssignWindow.sales = p.value || 0
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "18" },
                      on: { click: _vm.enterAssignHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "19" },
                      on: {
                        click: function($event) {
                          _vm.customerAssignWindow.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.checkingSaveJobWindow.visible
        ? _c("checking-save-job-window", {
            attrs: {
              visible: _vm.checkingSaveJobWindow.visible,
              lob: _vm.checkingSaveJobWindow.lob,
              "row-data": _vm.checkingSaveJobWindow.rowData,
              "check-node": _vm.checkingSaveJobWindow.checkNode,
              "call-back": _vm.checkingSaveJobWindow.callBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.checkingSaveJobWindow, "visible", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }